import React, { useEffect, useState } from 'react'
import { Formik } from 'formik'
import { Wrapper, Card } from '../../_components'
import Form from './Form'
import * as Yup from 'yup'
import  Axios  from 'axios'
import Theme from '../../Theme'
import { capitalize, getMaxFarmerId, generateSchemeCode, getDefaultDistrict } from '../../_utils'

const validationSchema = Yup.object().shape( {
  first_name: Yup.string().required( "First Name is Required" ),
  last_name: Yup.string().required( "Last Name is Required" ),
  district: Yup.string().required( "District is Required" ),
  subcounty: Yup.string().required( "Subcounty is Required" ),
  parish: Yup.string().required( "Parish is Required" ),
  village: Yup.string().required( "Village is Required" ),
  // primary_contact: Yup.string().required( "Phone Number is Required" ),
  secondary_contact: Yup.string(),
  co_phone: Yup.string(),
  nok_firstname: Yup.string().required( "Field is Required" ),
  nok_lastname: Yup.string().required( "Field is Required" ),
  nok_other: Yup.string(),
  relationship: Yup.string().required( "Field is Required" ),
  birthyear: Yup.string().required( "Field is Required" ),
  sex: Yup.string().required( "Field is Required" ),
  gender: Yup.string().required( "Field is Required" ),
  pwd: Yup.string(),
  youth: Yup.string(),
  block_number: Yup.string().required( "Block Number is Required" ),
  ffs_code: Yup.string().required( "FFSG Number / Name is Required" ),
  leader: Yup.string().required( "Field is Required" )
} )

export default function() {
  let tag = localStorage.getItem( "tag" )

  const [ phoneNumber, setPhone ] = useState( "" )
  const [ secondaryPhone, setSecondaryPhone ] = useState( "" )
  const [ coPhone, setCOPhone ] = useState( "" )
  const [ nokPhone, setNokPhone ]  = useState( "" )
  const [ loading, setLoading ] = useState( true )
  const [ farmerCode, setFarmerCode ] = useState( null )
  const [ farmerDetails, setFarmerDetails ] = useState( null )

  React.useEffect( () => {
    if( !tag ) {
      getMaxFarmerId( result => {
        const farmerCode = `${generateSchemeCode()}-${parseInt( result[ 0 ]?.farmerId ) + 1 }`
        setFarmerCode( farmerCode )
      } )
    }
  },[ tag ])

  React.useEffect( () => {
    if( tag ) {
      if( tag === "edit" || tag === "view"  ) {
        fetchEditFarmer()
      }
    }
  },[ loading ])

  const fetchEditFarmer = async () => {
    try {
      const response  = await Axios.get( `https://mis.nec.go.ug/api/auth/farmer/${localStorage.getItem( "farmerId" )}` )
      if( response.data ) {
        await setFarmerDetails( response.data?.records[ 0 ])
        setLoading( false )
      }
    } catch (error) {
      alert( "Farmer not found. Server error occured" )
      await localStorage.setItem( "name", "view_farmers"  )
      await  setLoading( false )
      return window.location.reload()
    }
  }



  const handleSubmit = async ( values ) => {
    const payload = {
      birthyear: values.birthyear || "",
      block_number: values.block_number || "",
      co_phone: coPhone || "",
      district: values.district || "",
      email: values.email || "",
      ffs_code: values.ffs_code || "",
      first_name: values.first_name || "",
      gender: values.gender || "",
      institution_type: values.leader === "Yes" ? values.institution_type : "",
      land_ownership: values.land_ownership || "",
      last_name: values.last_name || "",
      leader: values.leader || "",
      nin: values.nin || "",
      nokPhone: nokPhone || "",
      nok_firstname: values.nok_firstname || "",
      nok_lastname: values.nok_lastname || "",
      nok_other: values.nok_other || "",
      other_name: values.other_name || "",
      parish: values.parish || "",
      plot_size: values.plot_size || "",
      plotno: values.plotno || "",
      position: values.leader === "Yes" ? values.position: "",
      primary_contact: phoneNumber || "",
      pwd: values.pwd || "",
      registration_no: values.registration_no || "",
      relationship: values.relationship || "",
      secondary_contact: secondaryPhone || "",
      sex: values.sex || "",
      subcounty: values.subcounty || "",
      village: values.village || "",
      youth: values.youth || ""
    }
    
    if( tag === "edit" ) {
      //edit farmer
      try {
        const response = await Axios.patch( `https://mis.nec.go.ug/api/auth/farmer`, 
          { ...payload, 
            id: farmerDetails?.id, 
            scheme: localStorage.getItem( "scheme" ).replace( "_", " " ),
            // primary_contact: phoneNumber,
            // secondary_contact: secondaryPhone,
            // co_phone: coPhone,
            // nokPhone
          } 
        )

        if( response.data ){
          alert( `Farmer has been updated successfully.` )
          await localStorage.setItem( "name", "view_farmers" )
          window.location.reload()
        }
      } catch (error) {
        alert( "An error occured on the server." )
      }
    }
    else {
      //create new farmer
      try {
        const response = await Axios.post( `https://mis.nec.go.ug/api/auth/farmer`, 
          { ...payload, 
            scheme: localStorage.getItem( "scheme" ).replace( "_", " " ),
            // primary_contact: phoneNumber,
            // secondary_contact: secondaryPhone,
            // co_phone: coPhone,
            // nokPhone
          } 
        )

        if( response.data ){
          alert( "Farmer has been added successfully." )
          await localStorage.setItem( "name", "view_farmers" )
          window.location.reload()
        }
      } catch (error) {
        alert( "An error occured on the server." )
      }
    }
    
  }

  if( !farmerCode && !tag ) {
    return (
      <Wrapper>
        <div className="flex items-center">
          {`Loading Registration Farmer Number...`}
        </div>
      </Wrapper>
    )
  }

  if( tag && !farmerDetails ) {
    return (
      <Wrapper>
        <div className="flex items-center">
          {`Loading Farmer Details...`}
        </div>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <div onClick={ async () => {
          await localStorage.setItem( "name", "view_farmers" )
          return window.location.reload()
        } } className="flex cursor-pointer items-center justify-center bg-blue-500 rounded w-32 py-2 my-2">
          {Theme.BackIcon}
        <div className="mx-2 text-xs md:text-base lg:text-base text-white">
          {`Previous`}
        </div>
      </div>

      <div className="grid grid-cols-1 items-center">
        <Card icon={Theme.PlusIcon} title={`${tag ? `${capitalize( tag )} Registered Farmer`: `Register A New Farmer`}`}>
          <Formik initialValues={{
            registration_no: tag ? farmerDetails?.reg_number : `${farmerCode}`,
            nin: tag ? farmerDetails?.nin : "",
            first_name:  tag ? farmerDetails?.first_name : "",
            last_name:  tag ? farmerDetails?.last_name : "",
            other_name:  tag ? farmerDetails?.other_name : "",
            district:   tag ? farmerDetails?.district : `${getDefaultDistrict()}`,
            subcounty: tag ? farmerDetails?.farm_sub_county : "",
            parish: tag ? farmerDetails?.farm_parish : "",
            village: tag ? farmerDetails?.farm_village : "",
            birthyear: tag ? farmerDetails?.birthyear : "",
            sex: tag ? farmerDetails?.sex : "",
            gender: tag ? farmerDetails?.gender : "",
            youth: tag ? farmerDetails?.is_youth : "",
            pwd: tag ? farmerDetails?.is_pwd : "",
            email: tag ? farmerDetails?.email : "",
            primary_contact: tag ? farmerDetails?.primary_contact : "",
            secondary_contact: tag ? farmerDetails?.secondary_contact : "",
            co_phone: tag ? farmerDetails?.co_phone : "",
            nok_firstname: tag ? farmerDetails?.nok_firstname : "",
            nok_lastname: tag ? farmerDetails?.nok_lastname : "",
            nok_other: tag ? farmerDetails?.nok_other : "",
            relationship: tag ? farmerDetails?.nok_relationship : "",
            nok_phone: tag ? "" : "",
            block_number: tag ? farmerDetails?.block_id : "",
            ffs_code: tag ? farmerDetails?.name : "",
            plotno: tag ? farmerDetails?.plot_number : "",
            plot_size: tag ? farmerDetails?.plot_size : "",
            leader: tag ? farmerDetails?.is_leader : "",
            institution_type: tag ? farmerDetails?.institution_type : "",
            position: tag ? farmerDetails?.position : "",
            land_ownership: tag ? farmerDetails?.land_ownership : ""
        }} 
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}>
        { ( { values, errors, handleBlur, handleChange, handleSubmit } ) => {
            return (
            <form onSubmit={handleSubmit}>
                <Form 
                  tag 
                  details={farmerDetails}
                  setPhone={( phone ) => {
                    setPhone( phone )
                  } }
                  setSecondaryContact={( phone ) => {
                    setSecondaryPhone( phone )
                  } }
                  setCOPhone={( phone ) => {
                    setCOPhone( phone )
                  } }
                  setNOKPhone={( phone ) => {
                    setNokPhone( phone )
                  } }
                  values={values} 
                  handleChange={handleChange}
                  errors={errors}
                  handleBlur={handleBlur}/>
                { !( localStorage.getItem( "tag" ) === "view" ) &&
                ( <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
                  {localStorage.getItem( "tag" ) === "edit" ? `Update Farmer Details`: `Submit`}
                </button> ) }
            </form>
            )
        } }
          </Formik>
        </Card>
      </div>
    </Wrapper>
    
  )
    }
